<template>
  <div class="modal-backdrop d-flex text-center" v-if="updating">
    <div class="align-self-center" style="flex-grow: 1">
      <b-spinner variant="white" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  computed: {
    updating() {
      return this.$store.getters.spinner
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-backdrop {
  z-index: 1050;
}
</style>
